// https://stackoverflow.com/questions/5999998/check-if-a-variable-is-of-function-type
export const isFunction = obj => {
  return !!(obj && obj.constructor && obj.call && obj.apply);
};